import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { PointStoreProductEditService } from './point-store-product-edit.service';
import { PointStoreProductValidationService } from './point-store-product-validation.service';
import { PointStoreNavigationBarService } from './point-store-navigation-bar.service';
import { PointStoreCategoriesService } from './point-store-categories.service';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { PointStoreProductSave } from 'src/app/gamification/cv-marketplace-admin/models/point-store-product.model';
import { ToastrManager } from '@niceltd/sol/toastr';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CvCustomDialogService } from 'src/app/reusables/custom-dialog/cv-custom-dialog.service';

@Injectable({
  providedIn: 'root'
})
export class PointStoreProductEditSaveService {

  LocalizationMarket: any = null;
  LocalizationMarketManMessages: any = null;
  data: any = {}
  pspef: any = null;
  maxCharactersLength: number = 50;
  fileErrorException: string = '1';

  constructor(
    private pointStoreProductEditService: PointStoreProductEditService,
    private pointStoreCategoriesService: PointStoreCategoriesService,
    private pointStoreProductValidationService: PointStoreProductValidationService,
    private pointStoreNavigationBarService: PointStoreNavigationBarService,
    private cvLocalizationService: CVLocalizationService,
    private cvApiService: CVApiService,
    private cvConfigurationService: CvConfigurationService,
    private toastrManager: ToastrManager,
    private dialogService: CvCustomDialogService
  ) {
    this.cvLocalizationService.GetSection("Market").then(
      (result) => {
        this.LocalizationMarket = result;
      }
    );

    this.cvLocalizationService.GetSection("MarketPlace_Management_Messages").then(
      (result) => {
        this.LocalizationMarketManMessages = result;
      }
    );
    this.pspef = pointStoreProductEditService.pointStoreProductEditObj;
  }

  async removePointStoreProductByProductWS(PointStoreProductID) {
    try {
      this.pointStoreProductEditService.setUpgLoad(true);
      const url = "/api/v2/marketplace/admin/remove/" + PointStoreProductID + "/";
      let response: any = await this.cvApiService.post(url);
      if (response.status_code == 200) {
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Removing Point Store Product: " + error.message);
    } finally {
      this.pointStoreProductEditService.setUpgLoad(false);
    }
  }

  async removePointStoreProductID() {
    try {
      this.pointStoreProductEditService.setUpgLoad(true);
      const url = "/api/v2/marketplace/admin/remove/" + this.pspef.modifiedPointStoreProduct.PointStoreProductID + "/";
      let response: any = await this.cvApiService.post(url);
      if (response.status_code == 200) {
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Loading Remove Point Store Product: " + error.message);
    } finally {
      this.pointStoreProductEditService.setUpgLoad(false);
    }
  }

  async removePointStoreProducts() {
    let products = this.pointStoreProductEditService.pointStoreProductEditObj.collection.originalData.filter((item) => {
      if (item.IsChecked != undefined) {
        return item.IsChecked;
      }
      return false;
    });
    try {
      this.pointStoreProductEditService.setUpgLoad(true);
      const url = "/api/v2/marketplace/admin/remove/products/" + products + "/";
      let response: any = await this.cvApiService.post(url);
      if (response.status_code == 200) {
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Loading Remove Point Store Product: " + error.message);
    } finally {
      this.pointStoreProductEditService.setUpgLoad(false);
    }
  }

  async savePointStoreProductWSObj(isNew) {
    let editedProduct = null;
    this.pointStoreProductEditService.setUpgLoad(true);
    let product = this.pspef.modifiedPointStoreProduct;
    let imageString = [];
    let variationImageString = [];
    if (product.ProductImageID == 0 || isNew == false) {
      for (let i = 0; i < product.imageString.length; i++) {
        if (product.imageString[i].source.includes('imgid')) {
          let initialPosition = product.imageString[i].source.search("imgid");
          let finalPosition = product.imageString[i].source.search("&w=");
          imageString.push(product.imageString[i].source.substring(initialPosition + 6, finalPosition))
        } else
          imageString.push(product.imageString[i].source);
      }
    }
    if (imageString == undefined)
      imageString = [];

    //ask if we need this for cxone
    this.removeEmptyNewLineDescription(product);

    if(imageString.length > 0 && this.pspef.copiedProduct) {
      await this.formatMainImagesFromCloneOption(imageString);
    }
    if(product.VariationsData.length > 0 && this.pspef.copiedProduct) {
      const variationsData = await this.formatVariationImagesFromCloneOption(product.VariationsData);
      if(variationsData.length > 0) {
        product.VariationsData = product.VariationsData?.map((variation) => {
          const imageObj = variationsData.find(image => image.id === variation.PointStoreProductVariationID);
            return {
              ...variation,
              //If the image is not stored in the variationsData array then assign the current value
              VariationImageData : imageObj?.image ?? variation.VariationImageData,
            }
        });
      }
    }
    

    //Variation
    if (product.HasProductVariations) {
      switch (product.VariationName) {
        case "Types":
          product.VariationType = 0;
          break;
        case "Colors":
          product.VariationType = 1;
          break;
        case "Sizes":
          product.VariationType = 2;
          break;
        default:
          product.VariationType = 3;
          break;
      }
      product.IsOnSaleChecked = false;
      product.VariationsData.forEach((item, index, array) => {
        if (item.VariationOnSale == null) item.VariationOnSale = false;
        if (item.VariationOnSale) product.IsOnSaleChecked = true;
      });
      if (this.pointStoreProductEditService.pointStoreProductEditObj.variationTypes.indexOf(product.VariationName) === -1) {
        this.pointStoreProductEditService.pointStoreProductEditObj.variationTypes.push(product.VariationName);
      }
      for (let count = 0; count < product.VariationsData.length; count++) {
        if (product.VariationsData[count].VariationImageData != undefined && product.VariationsData[count].VariationImageData != null) {
          if (product.VariationsData[count].VariationImageData.includes('imgid')) {
            let initialPosition = product.VariationsData[count].VariationImageData.search("imgid");
            let finalPosition = product.VariationsData[count].VariationImageData.search("&w=");
            variationImageString.push(product.VariationsData[count].VariationImageData.substring(initialPosition + 6, finalPosition))
          } else
            variationImageString.push(product.VariationsData[count].VariationImageData);
        }
      }

    } else {
      product.HasVariationPrices = false;
      product.VariationType = null;
      product.VariationName = "";
    }

    let validation = this.pointStoreProductValidationService.getValidationOfStep(5); //************************* once validation facotry is ready
    if (!validation.succeeded) {
      const validationResponse = await this.pointStoreProductValidationService.showValidationErrorDialog(validation);
      /* this.pointStoreProductValidationService.showValidationErrorDialog(validation).then(
        (result) => { */
      switch (validationResponse) {
        case "ok": //standard error "ok" clicked
          //Do nothing as there was a validation error
          break;
        case "no": //warning, "no" clicked: don't continue
          //Do nothing as there was a warning and the user chose not to continue
          break;
        case "yes": //warning, "yes" clicked: continue
          //There was a warning, but the user chose to continue and save
          editedProduct = await this.addEditPointStoreProduct(product, imageString, variationImageString, product.PointStoreProductAllAssignments);
          break;
      }
      /* }
    ); */
    }

    if (validation.succeeded) {
      editedProduct = await this.addEditPointStoreProduct(product, imageString, variationImageString, product.PointStoreProductAllAssignments);
    }
    return editedProduct;
  }

  // send dates as local (no trailing 'Z') so the server keeps the picked calendar
  // day; a raw Date serializes to UTC and shifts the day back for users east of UTC (e.g. IST).
  private normalizeProductDates(product) {
    const f = (v) => { const d = new Date(v); return !v || isNaN(d.getTime()) ? v : `${d.getFullYear()}-${`${d.getMonth() + 1}`.padStart(2, '0')}-${`${d.getDate()}`.padStart(2, '0')}T00:00:00`; };
    return { ...product, ProductStart: f(product.ProductStart), ProductEnd: f(product.ProductEnd), CarouselStart: f(product.CarouselStart), CarouselEnd: f(product.CarouselEnd), SaleStart: f(product.SaleStart), SaleEnd: f(product.SaleEnd), FeatureStart: f(product.FeatureStart), FeatureEnd: f(product.FeatureEnd) };
  }

  async addEditPointStoreProduct(product, imageString, variationImageString, PointStoreProductAllAssignments) {
    try {
      this.pointStoreProductEditService.setUpgLoad(true);
      const body = {
        product: this.normalizeProductDates(product),
        bitString: imageString,
        variationImageString: variationImageString,
        ObjectAllAssignments: PointStoreProductAllAssignments,
        editImages: true,
        isCXOne: this.cvConfigurationService.isCxOne,
      }
      /* const url = "/api/v2/marketplace/admin/edit/products/" + product + "/" + imageString + "/" + variationImageString + "/" + PointStoreProductAllAssignments + "/" + true + "/";
      let response: any = await this.cvApiService.get(url); */
      const url = "/api/v2/marketplace/admin/edit/products";
      let response: any = await this.cvApiService.post(url, body);
      if (response.status_code == 200) {
        this.pspef.copiedProduct = false;
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage(error.message);
    } finally {
      this.pointStoreProductEditService.setUpgLoad(false);
    }
  }

  async savePointStoreProductsWSObj() {
    try {
      this.pointStoreProductEditService.setUpgLoad(true);
      const url = "/api/v2/marketplace/products/users/"; /***pending new url*/
      let response: any = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Loading Save Point Store Products: " + error.message);
    } finally {
      this.pointStoreProductEditService.setUpgLoad(false);
    }
  }

  copyPointStoreProduct(productToCopy) {
    let copyOfMessageCV = " - " + (this.LocalizationMarketManMessages.get("Copy") !== null ? this.LocalizationMarketManMessages.get("Copy") : "Copy");
    const copyOfMessage = this.cvLocalizationService.getCachedText('MarketPlace_Management_Messages','Copy_Of', 'Copy of');
    let copiedProduct = angular.copy(productToCopy);
    copiedProduct.PointStoreProductID = 0;
    if(this.cvConfigurationService.isCxOne){
      const title:string = copiedProduct.Title;
      copiedProduct.Title = '';
    }else{
      const cvTitle = copiedProduct.Title.substring(0, this.maxCharactersLength - copyOfMessageCV.length);
      copiedProduct.Title = cvTitle + copyOfMessageCV;
    }
    //Added to Avoid carrying the orderes from the source product (Thumbnail)
    copiedProduct.QuantityOrdered = 0;
    copiedProduct.ProductImageID = 0;
    return copiedProduct;
  }

  async saveMultiAssignmentPointStoreProductListViewWS(pointStoreProduct) {
    this.pointStoreProductEditService.setUpgLoad(true);
    let product = pointStoreProduct;
    let imageString = [];
    if (product.ProductImageID == undefined || product.ProductImageID == 0)
      imageString = product.imageString;
    if (imageString == undefined)
      imageString = [];
    if (product.Description == null) product.Description = '';
    try {
      const url = "/api/v2/marketplace/products/users/"; /***pending new url*/
      let response: any = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Save Point Store Product ListView: " + error.message);
    } finally {
      this.pointStoreProductEditService.setUpgLoad(false);
    }
  }

  async savePointStoreProductListViewWS(isNewImage = null) {
    this.pointStoreProductEditService.setUpgLoad(true);
    let product = this.pspef.modifiedPointStoreProduct;
    let imageString = [];
    let variationImageString = [];
    if (product.ProductImageID == 0 || isNewImage == true) {
      for (let i = 0; i < product.imageString.length; i++) {
        if (product.imageString[i].source.includes('imgid')) {
          let initialPosition = product.imageString[i].source.search("imgid");
          let finalPosition = product.imageString[i].source.search("&w=");
          imageString.push(product.imageString[i].source.substring(initialPosition + 6, finalPosition))
        } else
          imageString.push(product.imageString[i].source);
      }
    }
    if (imageString == undefined)
      imageString = [];
    if (product.Description == null) product.Description = '';

    if (product.HasProductVariations) {
      for (let count = 0; count < product.VariationsData.length; count++) {
        if (product.VariationsData[count].VariationImageData != undefined && product.VariationsData[count].VariationImageData != null) {
          if (product.VariationsData[count].VariationImageData.includes('imgid')) {
            let initialPosition = product.VariationsData[count].VariationImageData.search("imgid");
            let finalPosition = product.VariationsData[count].VariationImageData.search("&w=");
            variationImageString.push(product.VariationsData[count].VariationImageData.substring(initialPosition + 6, finalPosition))
          } else
            variationImageString.push(product.VariationsData[count].VariationImageData);
        }
      }
    }
    try {
      const url = "/api/v2/marketplace/products/users/"; /***pending new url*/
      let response: any = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Save Point Store Product ListView: " + error.message);
    } finally {
      this.pointStoreProductEditService.setUpgLoad(false);
    }
  }

  async savePointStoreProductsListViewWS(isLayoutOptions) {
    this.pointStoreProductEditService.setUpgLoad(true);
    let product = this.pspef.modifiedPointStoreProduct;
    product.Title = '';
    product.Description = '';
    product.Price = 0;

    let imageString = [];
    if (product.ProductImageID == 0)
      imageString = product.imageString;
    if (imageString == undefined)
      imageString = [];

    let products = this.pointStoreProductEditService.pointStoreProductEditObj.collection.originalData.filter((item) => {
      if (item.IsChecked != undefined) {
        return item.IsChecked;
      }
      return false;
    });
    try {
      const url = "/api/v2/marketplace/products/users/"; /***pending new url*/
      let response: any = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Loading Remove Point Store Product: " + error.message);
    } finally {
      this.pointStoreProductEditService.setUpgLoad(false);
    }
  }

  /*  saveAddEditPointStoreProduct() {
     if (this.pointStoreProductValidationService.validatePointStoreProductEditPage()) {
       this.savePointStoreProduct();
     }
   } */

  savePointStoreProduct() {
    let isNew = this.pointStoreProductEditService.pointStoreProductEditObj.modifiedPointStoreProduct.PointStoreProductID == 0;
    return this.savePointStoreProductWSObj(isNew).then(
      async (result) => {
        if (result) {
          this.pointStoreProductEditService.pointStoreProductEditObj.modifiedPointStoreProduct = angular.copy(result); /*pending test this first. If this doesn't work than assign PointStoreProductID*/

          this.pointStoreProductEditService.copyModifiedToOriginal();
          this.pointStoreProductEditService.pointStoreProductEditObj.modifiedPointStoreProduct.isNew = isNew;
          this.pointStoreProductEditService.pushPointStoreProductToCollection(); /**** this.pointStoreProductEditService.pushPointStoreProductToCollection(result); */
          //this.pointStoreCategoriesService.pushCategory(); //uncomment when pointStoreCategoriesService factory is ready*/
          this.pointStoreNavigationBarService.setSelectedFrame(0); //uncomment when pointStoreNavigationBarService factory is ready
          this.pointStoreProductEditService.resetAddEditUploader(); //Only matters if the user selects the same image again, but better safe than sorry!
          /**$rootScope.$broadcast('marketplaceProductsFilterChanged'); check this one! ?******/
          this.pointStoreProductEditService.setUpgLoad(false);
          this.pointStoreCategoriesService.data.isLoaded = false;
          await this.pointStoreCategoriesService.loadCategories(true);
        }
      }
    );
  }

  savePointStoreProducts() {
    this.savePointStoreProductsWSObj().then(
      (result) => {
        this.pointStoreProductEditService.pointStoreProductEditObj.modifiedPointStoreProduct = angular.copy(result); /*pending test this first. If this doesn't work than assign PointStoreProductID*/

        this.pointStoreProductEditService.copyModifiedToOriginal();
        this.pointStoreProductEditService.pushPointStoreProductToCollection(); // ********this.pointStoreProductEditService.pushPointStoreProductToCollection();
        /*pointStoreCategoriesFactory.pushCategory();******* uncomment when pointStoreNavigationBarService factory is ready*/
        /*pointStoreNavigationBarFactory.setSelectedFrame(0);******* uncomment when pointStoreNavigationBarService factory is ready*/
        this.pointStoreProductEditService.setUpgLoad(false);
      }
    );
  }

  removePointStoreProduct() {
    /* this.pointStoreProductValidationService.validateRemoveButton().then(
       function success(result) {
         this.removePointStoreProductID().then(
           function success(result) {
             this.pointStoreProductEditService.removePointStoreProductObjFromCollection();
             //pointStoreCategoriesFactory.removeCategory() ************* uncoment on service ready
             this.pointStoreProductEditService.setUpgLoad(false);
           }
         );
       }
     );*/
  }

  removePointStoreProductByProduct(product) {
    this.removePointStoreProductByProductWS(product.PointStoreProductID).then(
      (result) => {
        this.pointStoreProductEditService.removePointStoreProductObjFromCollection();
        this.pointStoreProductEditService.setUpgLoad(false);
      }
    );
  }

  async removeProduct(product) {
    try {
        this.pointStoreProductEditService.setUpgLoad(true);
        const url = "/api/v2/marketplace/admin/remove/" + product.PointStoreProductID + "/" + this.cvConfigurationService.isCxOne;
        let response = await this.cvApiService.post(url);
        if (response.status_code >= 200 && response.status_code < 300) {
            return response.data;
        }
        else throw response;
    } catch (error) {
        console.error(`Failed to remove PointStore Product.`);
        throw error;
    } finally {
        this.pointStoreProductEditService.setUpgLoad(false);
    }
  }

    confirmRemoveProduct(product):Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            window["showConfirmDialog"](this.LocalizationMarketManMessages.get("Validate_Remove_Product") ?? "Are you sure you want to remove the products selected? Continue anyway?",
                [
                    {
                        text: this.LocalizationMarketManMessages.get("Yes") ?? "Yes",
                        click: function () {
                            let dialogMsg: any = $(".errorDialog");
                            dialogMsg.dialog("close");
                            resolve(true);
                        }
                    },
                    {
                        text: this.LocalizationMarketManMessages.get("No") ?? "No",
                        click: function () {
                            let dialogMsg: any = $(".errorDialog");
                            dialogMsg.dialog("close");
                            resolve(false);
                        }
                    }
                ], this.LocalizationMarketManMessages.get("Order_Management_Validation_Warning") ?? "MarketPlace Order Management Validation Warning", "Warning");
        });
  }

  /*ListView*/
  getActiveToolbarPosition() {
    let position = 0;
    for (let i = 0; i < this.pointStoreProductEditService.pointStoreProductEditObj.landingListToolbar.toolbarAction.length; i++) {
      if (this.pointStoreProductEditService.pointStoreProductEditObj.landingListToolbar.toolbarAction[i].value) {
        position = i;
        break;
      }
    }
    return position;
  }

  savePointStoreProductListView(position) {
    // this.pointStoreProductValidationService.validatePointStoreProductListViewEditPage(position).then(
    //   (result) => {
    //     switch (position) {
    //       case 0: /* import */

    //         this.savePointStoreProductListViewWS().then(
    //           (result) => {
    //             this.pointStoreProductEditService.setUpgLoad(false);
    //           }
    //         );
    //         break;
    //       case 1: /* edit */
    //         this.savePointStoreProductListViewWS().then(
    //           (result) => {
    //             this.pointStoreProductEditService.saveEditList(result);
    //             this.pointStoreProductEditService.clearToolbarActions();
    //             this.pointStoreProductEditService.setNullPointStoreProduct();

    //             this.cancelPointStoreProductListView(true);
    //             this.pointStoreProductEditService.setUpgLoad(false);
    //           }
    //         );
    //         break;
    //       case 2: /* copy */

    //         this.savePointStoreProductListViewWS().then(
    //           (result) => {
    //             this.pointStoreProductEditService.saveEditList(result);
    //             this.pointStoreProductEditService.clearToolbarActions();
    //             this.pointStoreProductEditService.setNullPointStoreProduct();

    //             /***$rootScope.$broadcast('marketplaceProductsFilterChanged');******check this one*******/

    //             this.cancelPointStoreProductListView(true);
    //             this.pointStoreProductEditService.setUpgLoad(false);
    //           }
    //         );
    //         break;
    //       case 4: /* displayOptions */

    //         this.savePointStoreProductListViewWS().then(
    //           (result) => {
    //             this.pointStoreProductEditService.savePointStoreProductFromDisplayOptions(); //this.pointStoreProductEditService.savePointStoreProductFromDisplayOptions(result); ******
    //             this.cancelPointStoreProductListView(true);

    //             /*****$rootScope.$broadcast('marketplaceProductsFilterChanged');******check this one*******/

    //             this.pointStoreProductEditService.setUpgLoad(false);
    //           }
    //         );
    //         break;
    //       case 5: /* assignments */

    //         this.savePointStoreProductListViewWS().then(
    //           (result) => {
    //             this.pointStoreProductEditService.saveAssignmentList();
    //             this.cancelPointStoreProductListView(true);
    //             /*$rootScope.$broadcast('marketplaceProductsFilterChanged');******check this one*******/

    //             this.pointStoreProductEditService.setUpgLoad(false);
    //           }
    //         );
    //         break;
    //       case 6: /* multiEdit */
    //         let isLayoutOptions = true;
    //         this.savePointStoreProductsListViewWS(isLayoutOptions).then(
    //           (result) => {
    //             this.pointStoreProductEditService.saveMultiEditList(isLayoutOptions);
    //             this.pointStoreProductEditService.setNullPointStoreProduct();

    //             /*$rootScope.$broadcast('marketplaceProductsFilterChanged');******check this one*******/

    //             this.cancelPointStoreProductListView(true);

    //             this.pointStoreProductEditService.setUpgLoad(false);
    //           }
    //         );
    //         break;
    //       case 9: /* viewProductImageDetail */
    //         this.savePointStoreProductListViewWS(true).then(
    //           (result) => {
    //             this.pointStoreProductEditService.saveImageFromListView(result);
    //             this.cancelPointStoreProductListView(true);
    //             /*$rootScope.$broadcast('marketplaceProductsFilterChanged');******check this one*******/
    //             this.pointStoreProductEditService.setUpgLoad(false);
    //           }
    //         );
    //         break;
    //       case 12: /* add */
    //         this.savePointStoreProductListViewWS().then(
    //           (result) => {
    //             this.pointStoreProductEditService.saveEditList(result);
    //             this.pointStoreProductEditService.clearToolbarActions();

    //             /*$rootScope.$broadcast('marketplaceProductsFilterChanged');******check this one*******/

    //             this.cancelPointStoreProductListView(true);
    //             this.pointStoreProductEditService.setUpgLoad(false);
    //           }
    //         );
    //         break;
    //       case 13: /* multiAssignments */
    //         //pointStoreProductEditFactory.saveMultiAssignmentList();
    //         for (let i = 0; i < this.pointStoreProductEditService.pointStoreProductEditObj.collection.originalData.length; i++) {
    //           if (this.pointStoreProductEditService.pointStoreProductEditObj.collection.originalData[i].IsChecked == true) {
    //             //TODO PointStoreProductALLAssignments
    //             this.pointStoreProductEditService.pointStoreProductEditObj.collection.originalData[i].PointStoreProductAllAssignments = angular.copy(this.pointStoreProductEditService.pointStoreProductEditObj.modifiedPointStoreProduct.PointStoreProductAllAssignments);
    //             this.pointStoreProductEditService.pointStoreProductEditObj.collection.originalData[i].IsChecked = false;
    //             this.saveMultiAssignmentPointStoreProductListViewWS(this.pointStoreProductEditService.pointStoreProductEditObj.collection.originalData[i]).then(
    //               (result) => {
    //                 this.pointStoreProductEditService.setUpgLoad(false);
    //                 /*$rootScope.$broadcast('marketplaceProductsFilterChanged');******check this one*******/
    //               });
    //           }
    //         }
    //         this.pointStoreProductEditService.setNullPointStoreProduct();
    //         this.cancelPointStoreProductListView(true);
    //         break;
    //       case 14: /* New muti Edit popup */
    //         isLayoutOptions = false; //var isLayoutOptions = false;

    //         this.savePointStoreProductsListViewWS(isLayoutOptions).then(
    //           (result) => {
    //             this.pointStoreProductEditService.saveMultiEditList(isLayoutOptions);
    //             this.pointStoreProductEditService.setNullPointStoreProduct();

    //             /*$rootScope.$broadcast('marketplaceProductsFilterChanged');******check this one*******/

    //             this.cancelPointStoreProductListView(true);

    //             this.pointStoreProductEditService.setUpgLoad(false);
    //           }
    //         );
    //         break;
    //     }
    //   }
    // );
  }

  cancelPointStoreProductListView(byPassValidation) {
    // this.pointStoreProductValidationService.validateCancelButton(byPassValidation).then(
    //   (result) => {

    //     let position = this.getActiveToolbarPosition();
    //     switch (position) {

    //       case 0: /* import */
    //         //pointStoreProductEditFactory.deSelectedAll(); //Stuff is selected, but no other states have been set. So deselect it all.
    //         break;
    //       case 1: /* edit */
    //         this.pointStoreProductEditService.clickCancelListView();
    //         break;
    //       case 2: /* copy */
    //         this.pointStoreProductEditService.clickCancelListView();
    //         break;
    //       case 3: /* delete */
    //         this.pointStoreProductEditService.clickCancelListView();
    //         break;
    //       case 4: /* displayOptions */
    //         this.pointStoreProductEditService.clearToolbarActions();
    //         break;
    //       case 5: /* assignments */
    //         this.pointStoreProductEditService.clickCancelListView();
    //         this.pointStoreProductEditService.clearToolbarActions();
    //         break;
    //       case 6: /* multiEdit */
    //         this.pointStoreProductEditService.clearToolbarActions();
    //         this.pointStoreProductEditService.setNullPointStoreProduct();
    //         this.pointStoreProductEditService.pointStoreProductEditObj.landingListToolbar.selectAll = false;
    //         break;
    //       case 7: /* multiDelete */
    //         this.pointStoreProductEditService.clickCancelListView();
    //         break;
    //       case 9: /* viewProductImageDetail */
    //         this.pointStoreProductEditService.setToolbarAction(9, false);
    //         break;
    //       case 12: /* add */
    //         this.pointStoreProductEditService.clickCancelListView();
    //         this.pointStoreProductEditService.setNullPointStoreProduct();
    //         break;
    //       case 13: /* multiAssignments */
    //         this.pointStoreProductEditService.clickCancelListView();
    //         this.pointStoreProductEditService.clearToolbarActions();
    //         this.pointStoreProductEditService.setNullPointStoreProduct();
    //         this.pointStoreProductEditService.pointStoreProductEditObj.landingListToolbar.selectAll = false;
    //         break;
    //       case 14: /* multiEdit */
    //         this.pointStoreProductEditService.clearToolbarActions();
    //         this.pointStoreProductEditService.setNullPointStoreProduct();
    //         this.pointStoreProductEditService.pointStoreProductEditObj.landingListToolbar.selectAll = false;
    //         break;
    //     }

    //     this.pointStoreProductEditService.deSelectedAll();
    //     let selectAllCheckbox = $('#ProductListSelectAllCheckbox');
    //     if (selectAllCheckbox != null) {
    //       selectAllCheckbox.prop('checked', false);
    //     }
    //     this.pointStoreProductEditService.pointStoreProductEditObj.landingListToolbar.selectAll = false;
    //     return true;
    //   }
    // );
  }

  removePointStoreProductIDFromListView() {
    // this.pointStoreProductValidationService.validateDeleteListViewButton().then(
    //   (result: any) => {
    //     if (result) {
    //       this.removePointStoreProductID().then(
    //         (result) => {
    //           this.pointStoreProductEditService.removeIsCheckedPointStoreProduct();
    //           this.cancelPointStoreProductListView(true);

    //           this.pointStoreProductEditService.setUpgLoad(false);
    //         }
    //       )
    //     } else {
    //       this.cancelPointStoreProductListView(true);
    //     }
    //   }
    // );
  }

  removePointStoreProductsFromListView() {
    // this.pointStoreProductValidationService.validateDeleteListViewButton().then(
    //   (result) => {
    //     this.removePointStoreProducts().then(
    //       (result) => {
    //         this.pointStoreProductEditService.removeIsCheckedPointStoreProduct();
    //         this.cancelPointStoreProductListView(true);

    //         /*$rootScope.$broadcast('marketplaceProductsFilterChanged'); ******check this one*******/

    //         this.pointStoreProductEditService.setUpgLoad(false);
    //       }
    //     );
    //   }
    // );
  }

  removeEmptyNewLineDescription(product): void {
    if(product && product.Description && product.Description != '' && product.Description.length >= 1){
      const lastCharacter = product.Description.slice(-1);
      if(lastCharacter == '\n'){
        product.Description = product.Description.slice(0, -1);
      }
    }
  }
   
  async formatMainImagesFromCloneOption(imageString: any[]) {
    if(imageString.length > 0){
      let imageTags = document.getElementsByClassName('psp-image-main');
      if(imageTags.length > 0){
        for (let a = 0; a < imageString.length; a++) {
            let elementFromArray = imageString[a];
            for (let i = 0; i < imageTags.length; i++) {
              const image = imageTags[i] as HTMLImageElement;
              const srcImage = image.src;
              if(srcImage.includes('imgid') && srcImage.includes('&w=') && !srcImage.includes('base64')){
                const initialPosition = srcImage.search('imgid');
                const finalPosition = srcImage.search('&w=');
                const idFromImage = srcImage.substring(initialPosition + 6, finalPosition);
                if(idFromImage == elementFromArray){
                  const imageStringFromReader = await this.getImageString(srcImage);
                  if(imageStringFromReader != ''){
                    imageString[a] = imageStringFromReader;
                  }
                }
              }
            }
        }
      }
    }
  }

  async formatVariationImagesFromCloneOption(variations: any[]){
    let imagesList = [];
    if(variations.length > 0){
      for (let index = 0; index < variations.length; index++) {
        let elementFromArray = variations[index];
        if(elementFromArray.VariationImageData?.includes('imgid') && elementFromArray.VariationImageData?.includes('&w=') &&  !elementFromArray.VariationImageData?.includes('base64')){
          const imageStringFromReader = await this.getImageString(elementFromArray.VariationImageData);
          if(imageStringFromReader){
            imagesList.push({
              id: elementFromArray.PointStoreProductVariationID, 
              image: imageStringFromReader
            });
          }
        }      
      }
    }
    return imagesList;
  }

  async getImageString(imageUrl: any){
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      let reader  = new FileReader();
      reader.addEventListener("load", function () {
        resolve(reader.result);
      }, false);
      reader.onerror = () => {
        return reject('');
      }
      reader.readAsDataURL(blob);
    });
  }

  savePointStoreProductCXOne() {
    let isNew = this.pointStoreProductEditService.pointStoreProductEditObj.modifiedPointStoreProduct.PointStoreProductID == 0;
    return this.savePointStoreProductWSObjCXOne(isNew).then(
      async (result) => {
        if (result) {
          this.pointStoreProductEditService.pointStoreProductEditObj.modifiedPointStoreProduct = angular.copy(result); /*pending test this first. If this doesn't work than assign PointStoreProductID*/

          this.pointStoreProductEditService.copyModifiedToOriginal();
          this.pointStoreProductEditService.pointStoreProductEditObj.modifiedPointStoreProduct.isNew = isNew;
          this.pointStoreProductEditService.pushPointStoreProductToCollection(); /**** this.pointStoreProductEditService.pushPointStoreProductToCollection(result); */
          this.pointStoreNavigationBarService.setSelectedFrame(0); //uncomment when pointStoreNavigationBarService factory is ready
          this.pointStoreProductEditService.resetAddEditUploader(); //Only matters if the user selects the same image again, but better safe than sorry!
          this.pointStoreCategoriesService.data.isLoaded = false;
          this.pointStoreProductEditService.setVariationTypeList();
          await this.pointStoreCategoriesService.loadCategories(true);
          return result;
        }
      }
    );
  }

  async savePointStoreProductWSObjCXOne(isNew) {
    let editedProduct = null;
    let product = this.pspef.modifiedPointStoreProduct;
    let imageString = [];
    let variationImageString = [];
    if (product.ProductImageID == 0 || isNew == false) {
      for (let i = 0; i < product.imageString.length; i++) {
        if (product.imageString[i].source.includes('imgid')) {
          let initialPosition = product.imageString[i].source.search("imgid");
          let finalPosition = product.imageString[i].source.search("&w=");
          imageString.push(product.imageString[i].source.substring(initialPosition + 6, finalPosition))
        } else
          imageString.push(product.imageString[i].source);
      }
    }
    if (imageString == undefined)
      imageString = [];

    //ask if we need this for cxone
    /* this.removeEmptyNewLineDescription(product); */

    if(imageString.length > 0 && this.pspef.copiedProduct) {
      await this.formatMainImagesFromCloneOption(imageString);
    }
    if(product.VariationsData.length > 0 && this.pspef.copiedProduct) {
      const variationsData = await this.formatVariationImagesFromCloneOption(product.VariationsData);
      if(variationsData.length > 0) {
        product.VariationsData = product.VariationsData?.map((variation) => {
          const imageObj = variationsData.find(image => image.id === variation.PointStoreProductVariationID);
            return {
              ...variation,
              //If the image is not stored in the variationsData array then assign the current value
              VariationImageData : imageObj?.image ?? variation.VariationImageData,
            }
        });
      }
    }
    

    //Variation
    if (product.HasProductVariations) {
      switch (product.VariationName) {
        case "Types":
          product.VariationType = 0;
          break;
        case "Colors":
          product.VariationType = 1;
          break;
        case "Sizes":
          product.VariationType = 2;
          break;
        default:
          product.VariationType = 3;
          break;
      }
      product.IsOnSaleChecked = false;
      product.VariationsData.forEach((item, index, array) => {
        if (item.VariationOnSale == null) item.VariationOnSale = false;
        if (item.VariationOnSale) product.IsOnSaleChecked = true;
      });
      if (this.pointStoreProductEditService.pointStoreProductEditObj.variationTypes.indexOf(product.VariationName) === -1) {
        this.pointStoreProductEditService.pointStoreProductEditObj.variationTypes.push(product.VariationName);
      }
      for (let count = 0; count < product.VariationsData.length; count++) {
        if (product.VariationsData[count].VariationImageData != undefined && product.VariationsData[count].VariationImageData != null) {
          if (product.VariationsData[count].VariationImageData.includes('imgid')) {
            let initialPosition = product.VariationsData[count].VariationImageData.search("imgid");
            let finalPosition = product.VariationsData[count].VariationImageData.search("&w=");
            variationImageString.push(product.VariationsData[count].VariationImageData.substring(initialPosition + 6, finalPosition))
          } else
            variationImageString.push(product.VariationsData[count].VariationImageData);
        }
      }

    } else {
      product.HasVariationPrices = false;
      product.VariationType = null;
      product.VariationName = "";
    }
    
    editedProduct = await this.addEditPointStoreProductCXOne(product, imageString, variationImageString, product.PointStoreProductAllAssignments);
    
    return editedProduct;
  }

  async addEditPointStoreProductCXOne(product, imageString, variationImageString, pointStoreProductAllAssignments) {
    const productRequest: PointStoreProductSave = {
      product: this.normalizeProductDates(product),
      bitString: imageString,
      variationImageString: variationImageString,
      ObjectAllAssignments: pointStoreProductAllAssignments,
      editImages: true,
      isCXOne: this.cvConfigurationService.isCxOne,
    }

    let errorStatus: string = '';
    const isNewProduct: boolean = product.PointStoreProductID === 0 && this.pointStoreProductEditService.pointStoreProductEditObj.copiedProduct === false;
    try {
      const url = "/api/v2/marketplace/admin/edit/products";
      let response: any = await this.cvApiService.post(url, productRequest);
      if (response.status_code == 200) {
        const messageToaster = isNewProduct ?
          this.cvLocalizationService.getCachedText("MarketPlace_Management", "Product_Added_Successfully", "Product added successfully.") :
          this.pointStoreProductEditService.pointStoreProductEditObj.copiedProduct ?
            this.cvLocalizationService.getCachedText("MarketPlace_Management", "Product_Duplicated_Successfully", "Product duplicated successfully.") :
            this.cvLocalizationService.getCachedText("MarketPlace_Management", "Product_Modified_Successfully", "Product modified successfully.");

        this.toastrManager.showToaster('success', messageToaster);
        this.pspef.copiedProduct = false;
        return response.data;
      }
      else {
        if (response.status) {
          errorStatus = response.status;
        }
        throw response;
      }
    } catch (error) {
      this.displayCxoneServerErrorMessage(errorStatus);
    }
  }

  displayCxoneServerErrorMessage(message: string) {
    switch (message) {
      case this.fileErrorException:
        const modalOptions: NgbModalOptions = {
          keyboard: false,
          backdrop: 'static',
          centered: true,
        };
        const modalTitle = this.cvLocalizationService.getCachedText("MarketPlace_Management", "Error_Uploading_Image", "Error Uploading Image");
        const body = this.cvLocalizationService.getCachedText("MarketPlace_Management", "Internal_Server_Error_Try_Again_Later", "Internal server error. Try again later.");
        const okLabel = this.cvLocalizationService.getCachedText("Common", "Ok", "Ok");
        this.dialogService.showDialog(modalTitle, body, 2, '', okLabel, true, () => { }, () => { }, 'cxone-error-uploading-image-modal', false, modalOptions);
        break;
      default:
        this.toastrManager.showToaster('error', this.cvLocalizationService.getCachedText("MarketPlace_Management", "Internal_Server_Error_Try_Again_Later", "Internal server error. Try again later."));
        break;
    }
  }
}
